export default __webpack_public_path__ + "static/media/dark-close.cc75c022.svg";